<main class="mat-body">
    <div class="bg-white py-3" *ngIf="contract && !contract.isAdvisoryModelSuitabilityOrGDC()">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap justify-content-between align-items-end">
                        <div class="col-auto flex-shrink-1">
                            <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'operative.operate'|translate"></h1>
                        </div>
                        <div class="col-auto">
                            <i class="icon-operative-natural text-blue"></i>
                        </div>
                    </div>
                    <hr class="mt-1 mb-2" />
                </div>

            </div>
        </div>
    </div>
 <div  *ngIf="1==1">

        <mat-accordion class="operative"  [multi]="true" [displayMode]="'flat'">
            <!--Nuevo ADV-2351-->
            <mat-expansion-panel
                class="mat-elevation-z0"
                [expanded]="defaultSection === 'orderTypes'"
                (afterCollapse)="onAccordionChange()"
                (afterExpand)="onAccordionChange()">
                <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 font-weight-bold mb-0">Seleccione el tipo de operación y producto</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <form #formOperate="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                            <div class="bg-blue">
                                <div class="container">
                                    <div class="row">

                                        <div class="col-6">
                                            <mat-form-field class="full-width pt-2 my-4">
                                                <mat-select name="type" [placeholder]="'form.operative-type'|translate" required [disabled]="editing || readonly || isValidator" [(value)]="selectedTypeValue" (selectionChange)="onChangeOrderType($event)">
                                                    <ng-template ngFor let-allowedType [ngForOf]="arrTypes" let-i="index">
                                                        <mat-option [value]="allowedType.type" [ngSwitch]="allowedType.type">
                                                            <span *ngSwitchCase="OrderType.SUBSCRIPTION">{{ 'form.order-type.subscription'|translate }}</span>
                                                            <span *ngSwitchCase="OrderType.SUBSCRIPTION_PERIOD">{{ 'form.order-type.subscription-period'|translate }}</span
                                                            >
                                                            <span *ngSwitchCase="OrderType.REFUND">{{ 'form.order-type.refund'|translate }}</span>
                                                            <span *ngSwitchCase="OrderType.REFUND_PERIOD">{{ 'form.order-type.refund-period'|translate }}</span>
                                                            <span *ngSwitchCase="OrderType.INTERNAL_TRANSFER">{{ 'form.order-type.internal-transfer'|translate }}</span
                                                            >
                                                            <span *ngSwitchCase="OrderType.EXTERNAL_TRANSFER"
                                                                >{{ 'form.order-type.external-transfer-other'|translate }}</span
                                                            >
                                                        </mat-option>
                                                    </ng-template>
                                                </mat-select>

                                                   </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field class="full-width pt-2 my-4">

                                                <!--seleccionar uno de los fondos-->
                                                <mat-select name="type" [placeholder]= "fundsplaceholder" required [disabled]="editing || readonly || isValidator" [(value)]="selectedFundValue" (selectionChange)="onChangeFund($event)" >

                                                    <ng-template ngFor let-fund [ngForOf]="arrFunds" let-i="index">
                                                        <mat-option [value]="fund.encryptedCode.value">
                                                            <span>{{fund.name}}</span>

                                                        </mat-option>
                                                    </ng-template>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="container">
                                <div class="row justify-content-between mb-5">
                                    <div class="col-12 col-sm-6 col-md-4">
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0" *ngIf="!readonly">
                                        <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!(selectedTypeValue && selectedFundValue)" (click)="onOperate($event)"><!--!formOperate.valid-->
                                            {{ 'general.accept'|translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </form>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel
                class="pending-orders mat-elevation-z0"
                [expanded]=" defaultSection === 'pending'"
                (afterCollapse)="onAccordionChange()"
                (afterExpand)="onAccordionChange()"
                *ngIf="ordersPending.length > 0">
                <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 font-weight-bold mb-0">{{ 'operative.my-pending-orders'|translate }}</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ng-template ngFor let-product [ngForOf]="ordersPending">
                                <thr-order-card
                                    [product]="product"
                                    [canSign]="user && user.canSign"
                                    (detail)="onOrderDetail($event)"
                                    (download)="onOrderDownload(product)"
                                    (upload)="onOrderUpload(product, $event)"
                                    (validate)="onOrderValidate(product)"
                                    (sign)="onOrderSign($event, product)"
                                    (remember)="onRememberOrder($event, product)"
                                    (viewDocument)="onViewDocument($event)"
                                    (removeDocument)="onRemoveDocument($event)"
                                ></thr-order-card>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="cancel-orders mat-elevation-z0"
                [expanded]="ordersDraft.length === 0 && ordersPending.length === 0"
                (afterCollapse)="onAccordionChange()"
                (afterExpand)="onAccordionChange()"
                *ngIf="ordersCanceled.length > 0">
                <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 font-weight-bold mb-0">{{ 'operative.my-cancel-orders'|translate }}</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ng-template ngFor let-product [ngForOf]="ordersCanceled">
                                <thr-order-card
                                    [product]="product"
                                    (detail)="onOrderDetail($event)"
                                    (viewDocument)="onViewDocument($event)"
                                    (removeDocument)="onRemoveDocument($event)"
                                ></thr-order-card>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="period-orders mat-elevation-z0"
                [expanded]="(ordersDraft.length === 0 && ordersPending.length === 0
                                 && ordersCanceled.length === 0) || defaultSection === 'period'"
                (afterCollapse)="onAccordionChange()"
                (afterExpand)="onAccordionChange()"
                *ngIf="ordersPeriod.length > 0">
                <mat-expansion-panel-header [collapsedHeight]="'60px'" [expandedHeight]="'60px'">
                    <mat-panel-title>
                        <h2 class="mat-subheading-1 font-weight-bold mb-0">{{ 'operative.my-period-orders'|translate }}</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ng-template ngFor let-product [ngForOf]="ordersPeriod">
                                <thr-order-card
                                    [product]="product"
                                    [canSign]="user && user.canSign"
                                    [canEdit]="product.isSubscriptionActive()"
                                    [canDelete]="product.isSubscriptionActive()"
                                    (detail)="onOrderDetail($event)"
                                    (edit)="onOrderEdit($event)"
                                    (cancelPeriod)="onOrderCancelPeriod($event)"
                                    (download)="onOrderDownload(product)"
                                    (upload)="onOrderUpload(product, $event)"
                                    (validate)="onOrderValidate(product)"
                                    (sign)="onOrderSign($event, product)"
                                    (remember)="onRememberOrder($event, product)"
                                    (viewDocument)="onViewDocument($event)"
                                    (removeDocument)="onRemoveDocument($event)"
                                ></thr-order-card>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</main>

<div class="d-none">
    <form #formLogalty name="formLogalty" id="formLogalty" method="POST" [attr.action]="formLogaltyAction">
        <input type="hidden" id="saml_assertion" name="saml_assertion" [attr.value]="formLogaltyXml" />
    </form>
</div>
